module.exports = __webpack_public_path__ + "img/youj.1b805a35.png";